import { storage } from '@visiba/std';
import type { DynamicFormAnswers } from '@api_patient/dynamic_forms_api.service';
import type { BasketStorageData } from '@view/view_booking/booking_basket.service';

export const applicationSessionStorage = storage<{
	showAlias: boolean;
	dynamicForms: Record<Guid, Record<number, DynamicFormAnswers>>;
	bookingBasket: Record<number, BasketStorageData>;
}>({ type: 'session' });
